const { getElement } = window.BAO.Utils

export class SiteDrawer extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.drawers = getElement('site-drawers')
    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }
    this.drawers.drawers.push(this)

    this._isOpen = false
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.drawerShouldBeMoved) {
      window.setTimeout(() => {
        this.moveToElement.appendChild(this)
      }, parseInt(this.getAttribute('data-module-drawers-move-delay'), 10) || 0)
    }
  }

  setupListeners () {
    super.setupListeners()

    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.listeners.add(document, 'keydown', this.handleKeyDown)
  }

  get key () {
    return this.getAttribute('key')
  }

  get elements () {
    return {
      trigger: getElement(`[data-drawers-trigger=${this.key}]`),
      close: getElement(`[data-module-drawers-close=${this.key}]`),
    }
  }

  get isOpen () {
    return this._isOpen
  }

  set isOpen (val) {
    const changed = this._isOpen !== val
    this._isOpen = val

    this.classList.toggle(this.config.classes.activeDrawerClass, val)

    if (!changed) return

    if (val) {
      this.onOpen()
    } else {
      this.onClose()
    }
  }

  onOpen () {
    this.activeTrigger = document.activeElement

    setTimeout(() => {
      const focusTarget =
        this.querySelector('[data-drawers-close]') ||
        this.getFocusableElements()[0]
      if (focusTarget) focusTarget.focus()
    }, 500)
  }

  onClose () {
    if (this.activeTrigger) {
      this.activeTrigger.focus()
      this.activeTrigger = null
    }
  }

  handleKeyDown (event) {
    if (!this.isOpen) return

    if (event.key === 'Escape') {
      this.drawers.closeDrawer()
      return
    }

    if (event.key === 'Tab') {
      this.trapFocus(event)
    }
  }

  trapFocus (event) {
    const focusableEls = this.getFocusableElements()
    if (!focusableEls.length) return

    const firstFocusableEl = focusableEls[0]
    const lastFocusableEl = focusableEls[focusableEls.length - 1]

    if (event.shiftKey && document.activeElement === firstFocusableEl) {
      event.preventDefault()
      lastFocusableEl.focus()
    } else if (!event.shiftKey && document.activeElement === lastFocusableEl) {
      event.preventDefault()
      firstFocusableEl.focus()
    }
  }

  getFocusableElements () {
    const selector =
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'

    // push-cart: upsell is a sibling rather than a drawer, also target that
    const extra = this.getAttribute('data-drawers-focus-extra')
    const roots = extra ? [this, ...document.querySelectorAll(extra)] : [this]

    return roots
      .flatMap(root => Array.from(root.querySelectorAll(selector)))
      .filter(el => !el.closest('[hidden]') && el.getClientRects().length > 0)
  }

  get drawerShouldBeMoved () {
    return this.hasAttribute('data-module-drawers-move-me')
  }

  get moveToElement () {
    switch (this.getAttribute('data-module-drawers-move-me')) {
      case 'root':
        return this.drawers
      default:
        return getElement(this.getAttribute('data-module-drawers-move-me'))
    }
  }

  get config () {
    return {
      classes: {
        activeDrawerClass: 'drw-Drawer-active',
      },
    }
  }
}

customElements.define('site-drawer', SiteDrawer)
